import React from 'react';

interface TranslatorData {
  input?: string;
  output?: string;
  to?: string;
  explanation?: string;
  error?: string;
}

interface Props {
  data: TranslatorData;
  isDarkMode?: boolean;
}

export const TranslatorCard: React.FC<Props> = ({ data, isDarkMode = false }) => {
  const border = isDarkMode ? 'border-slate-700' : 'border-slate-200';
  const bg = isDarkMode ? 'bg-slate-900/40 text-white' : 'bg-white/70';
  const textMuted = isDarkMode ? 'text-white/70' : 'text-black/70';

  if (data.error) {
    return (
      <div className={`rounded-lg p-2 my-2 border ${border} ${bg}`}>❌ {data.error}</div>
    );
  }

  return (
    <div className={`rounded-lg bg-transparent`}>
      {data.input && <div className={`text-sm mb-1 ${textMuted}`}>"{data.input}"</div>}
      {data.output && <div className="text-base font-semibold">{data.output}</div>}
      {data.explanation && (
        <div className={`text-sm mt-1 ${textMuted}`}><p className='inline font-semibold opacity-60'>EXPLANATION: </p>{data.explanation}</div>
      )}
    </div>
  );
};

export default TranslatorCard;
